import Image from "next/image";

import numeral from "numeral";
import { twMerge } from "tailwind-merge";

import CollectionCardButtons from "components/CollectionCardButtons";
import CustomCard from "components/CustomCard";
import useMediaQuery from "hooks/useMediaQuery";

const CollectionPageHeader = ({ collection }: any) => {
  const { mobile } = useMediaQuery();

  const {
    slug,
    name,
    coverImageUrl,
    description,
    totalInsights,
    totalCombinedRead,
    totalFollowers,
  } = collection;

  return (
    <CustomCard
      className={twMerge(
        "p-0",
        "mx-[-5px] mt-[-10px] mb-[-10px] rounded-none",
        "md:mx-0 md:mt-0 md:mb-[15px] md:rounded-xl",
        "bg-gradient-to-br from-[#1F1F20] to-[#0D4567]",
        "md:bg-none",
        "text-white",
        "md:text-active-black"
      )}
    >
      <div className="">
        <div
          className={twMerge(
            "w-full h-[32px] md:h-auto rounded-t-xl",
            "bg-gradient-to-r from-[#163243] to-[#0D4567]",
            "flex"
          )}
        >
          <div
            className={twMerge(
              "text-inactive-gray text-[14px]",
              "border border-solid border-inactive-gray",
              "px-[4px] md:py-[1px]",
              "ml-[15px] my-[5px]",
              "md:mt-[18px] md:mb-[14px] md:ml-[204px]"
            )}
          >
            COLLECTION
          </div>
        </div>
        <div className={twMerge("md:pl-[33px] md:pr-[33px]")}>
          <div
            className={twMerge(
              "absolute shadow-lg",
              "rounded-xl",
              "w-[108px] h-[108px] mt-[-22px] left-0 right-0 mx-auto",
              "md:w-[152px] md:h-[152px] md:mt-[-38px] md:left-auto md:right-auto md:mx-0",
              "border border-solid border-inactive-gray"
            )}
          >
            <Image
              className={twMerge("rounded-xl")}
              src={coverImageUrl?.xlarge}
              width={mobile ? 106 : 150}
              height={mobile ? 106 : 150}
              alt={name}
            />
          </div>
          <div
            className={twMerge(
              "w-full",
              "pt-[100px]",
              "md:pl-[170px] md:pt-[29px]"
            )}
          >
            <div className={twMerge("flex", "flex-col", "md:flex-row")}>
              <h1 className="flex-1 leading-[1.5]">
                <div
                  className={twMerge(
                    "md:text-active-black",
                    "text-[26px] font-black text-center",
                    "md:text-[36px] md:text-left"
                  )}
                >
                  {name}
                </div>

                <div
                  className={twMerge(
                    "flex",
                    "flex-col text-center",
                    "md:flex-row md:text-left md:space-x-2 md:min-h-[35px]"
                  )}
                >
                  {!!description && (
                    <div
                      className={twMerge(
                        "text-[14px] font-normal",
                        "md:text-[18px] md:text-[#555]"
                      )}
                    >
                      {description}
                    </div>
                  )}
                </div>
              </h1>

              <div className="text-right flex-col hidden md:flex">
                <div className={twMerge("mr-[-6px] mb-[5px] flex-1")}>
                  <div>
                    <CollectionCardButtons slug={slug} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr className="bg-gray-400 hidden md:block" />

          <div
            className={twMerge(
              "flex items-center",
              "flex-col",
              "md:flex-row md:pb-[13px] md:space-x-[40px]"
            )}
          >
            <div
              className={twMerge("flex space-x-[38px]", "my-[20px]", "md:my-0")}
            >
              {totalInsights ? (
                <div className="text-center min-w-[55px]">
                  <div className="text-[16px] font-black">
                    {totalInsights > 999
                      ? numeral(totalInsights).format("0.0a")
                      : totalInsights}
                  </div>
                  <div className="text-[11px]">Insights</div>
                </div>
              ) : null}
              {totalCombinedRead ? (
                <div className="text-center min-w-[55px]">
                  <div className="text-[16px] font-black">
                    {totalCombinedRead > 999
                      ? numeral(totalCombinedRead).format("0.0a")
                      : totalCombinedRead}
                  </div>
                  <div className="text-[11px]">Views</div>
                </div>
              ) : null}
              {totalFollowers ? (
                <div className="text-center min-w-[55px]">
                  <div className="text-[16px] font-black">
                    {totalFollowers > 999
                      ? numeral(totalFollowers).format("0.0a")
                      : totalFollowers}
                  </div>
                  <div className="text-[11px]">Followers</div>
                </div>
              ) : null}
            </div>

            <div className={twMerge("md:hidden", "mb-[20px] flex")}>
              <CollectionCardButtons slug={slug} />
            </div>
          </div>
        </div>
      </div>
    </CustomCard>
  );
};

export default CollectionPageHeader;
